import { Build, MonetizationOn, SettingsOutlined } from '@mui/icons-material'

import Routes from '@tabeeb/routes'
import { useSelector } from '@tabeeb/store'
import { TenantPermission } from '@tabeeb/enums'
import { appConfigStateSelectors } from '@tabeeb/modules/appConfigState'
import { getAvailableAnnouncementScopes } from '@tabeeb/modules/articles/selectors'
import { NavbarItem } from '@collaborate-health/uikit'
import { hasTenantPermission } from '@tabeeb/modules/permissions/selectors'

const SettingsTab: React.FC = () => {
  const showTenantSettings = useSelector((state) => hasTenantPermission(state, TenantPermission.TenantSettings))
  const showBillingSettings = useSelector(
    (state) =>
      hasTenantPermission(state, TenantPermission.BillingSettings) ||
      hasTenantPermission(state, TenantPermission.SessionApprovalSettings)
  )
  const showAnnouncements = useSelector((state) => getAvailableAnnouncementScopes(state).length > 0)
  const showDevices = useSelector((state) => hasTenantPermission(state, TenantPermission.Devices))
  const showContracts = useSelector(
    (state) =>
      hasTenantPermission(state, TenantPermission.ContractsManagement) &&
      (appConfigStateSelectors.getIsIncomingContractsEnabled(state) ||
        appConfigStateSelectors.getIsOutgoingContractsEnabled(state))
  )
  const showWorkflows = useSelector((state) => hasTenantPermission(state, TenantPermission.ManageWorkflows))
  const showSalesforceIntegration = useSelector((state) =>
    hasTenantPermission(state, TenantPermission.ViewSalesforceIntegrationNodes)
  )

  const showAllUsers = useSelector((state) => hasTenantPermission(state, TenantPermission.AllUsersView))

  const subitems = []

  if (showTenantSettings) {
    subitems.push({ label: 'Tenant settings', to: Routes.tenantConfig, icon: <Build /> })
  }

  if (showAnnouncements) {
    subitems.push({ label: 'Announcements', to: Routes.announcements })
  }

  if (showBillingSettings) {
    subitems.push({
      label: 'Billing settings',
      to: Routes.billingSettings,
      icon: <MonetizationOn />,
    })
  }

  if (showContracts) {
    subitems.push({ label: 'Contracts', to: Routes.contractorsBase })
  }

  if (showDevices) {
    subitems.push({ label: 'Devices', to: Routes.devices })
  }

  if (showAllUsers) {
    subitems.push({ label: 'Users', to: Routes.allUsers })
  }

  if (showWorkflows) {
    subitems.push({ label: 'Workflows', to: Routes.workflows })
  }

  if (showSalesforceIntegration) {
    subitems.push({ label: 'Salesforce integration', to: Routes.salesforce })
  }

  if (subitems.length === 0) {
    return null
  }

  return (
    <NavbarItem name='Settings' href={subitems[0].to} icon={<SettingsOutlined />}>
      {subitems.map((item) => (
        <NavbarItem key={item.label} subitem href={item.to} name={item.label} />
      ))}
    </NavbarItem>
  )
}

export default SettingsTab

